import type { ProfileEditable } from "./services/CabinetProfileApi";

/**
 * `Ф3` (кабинет ПЗС): что уходит в `PATCH /my/profile` и проверки пароля.
 *
 * В тело попадают **только** поля, которые человек правит сам (`Л9`): фамилия,
 * имя, отчество, телефон. Почта, роль и состояние — не отправляются вовсе, а не
 * «отбрасываются сервером»: лишнее поле — отказ (`Р9`), и клиент не должен его
 * провоцировать.
 */

export type ProfileFormValues = {
  lastName: string;
  firstName: string;
  surName: string;
  tel: string;
};

export function profilePayloadOf(values: ProfileFormValues): ProfileEditable {
  return {
    lastName: values.lastName.trim(),
    firstName: values.firstName.trim(),
    surName: values.surName.trim(),
    tel: values.tel.trim(),
  };
}

export const PASSWORD_MIN_LENGTH = 8;

/** Проверка пароля до запроса: длина, совпадение, отличие от текущего. */
export function passwordErrorOf({
  currentPassword,
  newPassword,
  repeatPassword,
}: {
  currentPassword: string;
  newPassword: string;
  repeatPassword: string;
}): string | null {
  if (!currentPassword) return "Введите текущий пароль";

  if (newPassword.length < PASSWORD_MIN_LENGTH) {
    return `Новый пароль — не короче ${PASSWORD_MIN_LENGTH} знаков`;
  }

  if (newPassword !== repeatPassword) return "Пароли не совпадают";

  if (newPassword === currentPassword) {
    return "Новый пароль совпадает с текущим";
  }

  return null;
}
